import React, { useEffect } from 'react';
import SignUp from "./auth/login";
import { ResetPassword } from './auth/ResetPassword';
import Appointments from "./components/insurance/appointments/appointments";
import AppointmentConfirmedProvider from "./components/provider/appointments/appointments";
import RequestProviderHistory from "./components/provider/history/request-history";
import CreateOrder from "./components/provider/createorder/createorder";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";

import CreateAppointment from "./components/insurance/create-appointment/create-appointment";
import ESalesQueue from './components/insurance/esalesqueue/esalesqueue';
import ErrorScreen from "./auth/errorScreen";
import { Route, Switch, Redirect } from "react-router-dom";
import { ProtectedRouteInsurance } from "./router/ProtectedRouteInsurance";
import { ProtectedRouteProvider } from "./router/ProtectedRouteProvider";
import RequestHistory from './components/insurance/history/request-history';
import EsalesRequestHistory from './components/insurance/history/esale-request-history';
import DocumentsProvider from './components/provider/documents/documents';
import ClevertapReact from 'clevertap-react';
import { ToastContainer } from "react-toast";

import { ProvidersAffiliateOrders, ValidateLocalStorageToken } from "./constants/provider/constant";

import { DashboardRouteProvider } from './router/DashboardRouteProvider';
import Dashboard from './components/dashboard/Dashboard';
import { AllAppointments } from './components/centralOms/allAppointments';
import { UpcomingAppointments } from './components/centralOms/upcomingAppointments';
import { ConfirmedAppointments } from './components/centralOms/confirmedAppointments';
import { DocumentUploadAppointments } from './components/centralOms/documentUpload';
import { CancelledAppointments } from './components/centralOms/cancelledAppointments';
import { NewAppointments } from './components/providerV2/pages/newAppointments';
import { ConfirmedAppointmentsLabs } from './components/providerV2/pages/confirmed';
import { CancelledAppointmentsLabs } from './components/providerV2/pages/cancelled';
import { DocumentsPending } from './components/providerV2/pages/documentsPending';
import { DocumentsSubmitted } from './components/providerV2/pages/documentsSubmitted';
import { ParitalDocumentsReceived } from './components/providerV2/pages/partialDocuments';
import { SettledAppointments } from './components/providerV2/pages/settled';
import { RejectedAppointments } from './components/providerV2/pages/rejected';
import { NotAttended } from './components/providerV2/pages/notAttended';
import { AllAppointmentsLabs } from './components/providerV2/pages/all';
import { DoctorManagement } from './components/DoctorMangement/DoctorManagement';
import { PageRouter } from './components/DoctorMangement/Doctor';
import { SPOCList } from "./components/SPOC/SpocList"
import { AddEditSpoc } from "./components/SPOC/AddEditSpoc"
import Chart from './components/EsalesChart/Chart';
import { fetchUserDetailsAndSetUserForAnalytics } from './helper/events'
import  UserFeaturesProvider from './hook/UserDetails/UserFeaturesProvider';
import { returnRoleBasedOnRoleId } from './helper/utils';
import { FEATURE_NAME } from './components/DoctorMangement/constant';
import { ForgotPassword } from './auth/ForgotPassword';

ClevertapReact.initialize("649-47W-Z55Z");
const checkInsurance = ['ins-stage.medibuddy.in', 'ins.medibuddy.in'].includes(window.location.host);

const theme = createTheme({
  typography: {
    fontFamily:  "Lexend Deca, sans-serif",
  },
});

function App() {
  useEffect(() => {
    if (window.location.hostname === 'labwise.medibuddy.in') {
      window.location.href = 'https://provider-central.medibuddy.in';
    }
  }, []);

  return (
    <ThemeProvider theme={theme}>
    <CssBaseline />
    <div className={checkInsurance ? 'head-tag-background-active min-h-screen' : 'min-h-screen'}>
      <Switch>
        <Route exact path="/login/:token/:id" component={SignUp} />
        <Route exact path="/login" component={SignUp} />
        <Route exact path="/ResetPassword" component={ResetPassword} />
        <Route exact path="/ForgotPassword" component={ForgotPassword} />
        <Route exact path="/">
          {
            ValidateLocalStorageToken(localStorage.getItem("user_details")) ? (
              JSON.parse(localStorage.getItem("user_details")).roleId === 9211 ? (
                <Redirect to="/insureragent/appointments/esalesqueue" />
              ) : localStorage.getItem("serviceSelected") === "LABS" ? (
                <Redirect to={"/" + returnRoleBasedOnRoleId(JSON.parse(localStorage.getItem("user_details")).roleId) + "/appointments"} />
              ) : (
                <Redirect to={"/offlineConsults/upcoming"} />
              )
            ) : (
              <Redirect to={"/insureradmin/appointments"} />
            )
          }
        </Route>

        <ProtectedRouteInsurance exact path="/insureradmin/appointments" component={Appointments} />
        <ProtectedRouteInsurance exact path="/insureradmin/appointments/:requestId/history" component={RequestHistory} />
        <ProtectedRouteInsurance exact path="/insureradmin/appointments/create" component={CreateAppointment} />
        <ProtectedRouteInsurance exact path="/insureradmin/appointments/esalesqueue" component={ESalesQueue} />
        <ProtectedRouteInsurance exact path="/insureradmin/charts" component={Chart} />
        <ProtectedRouteInsurance exact path="/insureradmin/appointments/esalesqueue/:esaleId/history" component={EsalesRequestHistory} />

        <ProtectedRouteInsurance exact path="/insureragent/appointments" component={Appointments} />
        <ProtectedRouteInsurance exact path="/insureragent/appointments/:requestId/history" component={RequestHistory} />
        <ProtectedRouteInsurance exact path="/insureragent/appointments/esalesqueue" component={ESalesQueue} />
        <ProtectedRouteInsurance exact path="/insureragent/charts" component={Chart} />
        <ProtectedRouteInsurance exact path="/insureragent/appointments/esalesqueue/:esaleId/history" component={EsalesRequestHistory} />

        <ProtectedRouteInsurance exact path="/insurerbranch/appointments" component={Appointments} />
        <ProtectedRouteInsurance exact path="/insurerbranch/appointments/:requestId/history" component={RequestHistory} />
        <ProtectedRouteInsurance exact path="/insurerbranch/appointments/esalesqueue" component={ESalesQueue} />
        <ProtectedRouteInsurance exact path="/insurerbranch/charts" component={Chart} />
        <ProtectedRouteInsurance exact path="/insurerbranch/appointments/esalesqueue/:esaleId/history" component={EsalesRequestHistory} />

        <ProtectedRouteInsurance exact path="/insurercallCentre/appointments" component={Appointments} />
        <ProtectedRouteInsurance exact path="/insurercallCentre/appointments/:requestId/history" component={RequestHistory} />
        <ProtectedRouteInsurance exact path="/insurercallCentre/appointments/create" component={CreateAppointment} />
        <ProtectedRouteInsurance exact path="/insurercallCentre/appointments/esalesqueue" component={ESalesQueue} />
        <ProtectedRouteInsurance exact path="/insurercallCentre/appointments/esalesqueue/:esaleId/history" component={EsalesRequestHistory} />
        <ProtectedRouteInsurance exact path="/insurercallCentre/charts" component={Chart} />





        <ProtectedRouteProvider exact path="/dcadmin/appointments/all" featureName ={FEATURE_NAME.VIEW_LABS} component={AllAppointmentsLabs} />
        <ProtectedRouteProvider exact path="/dcadmin/appointments" featureName ={FEATURE_NAME.VIEW_LABS} component={NewAppointments} />
        <ProtectedRouteProvider exact path="/dcadmin/appointments/confirmed" featureName ={FEATURE_NAME.VIEW_LABS} component={ConfirmedAppointmentsLabs} />
        <ProtectedRouteProvider exact path="/dcadmin/documents/pending" featureName ={FEATURE_NAME.VIEW_LABS} component={DocumentsPending} />
        <ProtectedRouteProvider exact path="/dcadmin/documents/partialReceived" featureName ={FEATURE_NAME.VIEW_LABS} component={ParitalDocumentsReceived} />
        <ProtectedRouteProvider exact path="/dcadmin/documents/received" featureName ={FEATURE_NAME.VIEW_LABS} component={DocumentsSubmitted} />
        <ProtectedRouteProvider exact path="/dcadmin/cases/settled" featureName ={FEATURE_NAME.VIEW_LABS} component={SettledAppointments} />
        <ProtectedRouteProvider exact path="/dcadmin/cases/cancelled" featureName ={FEATURE_NAME.VIEW_LABS} component={CancelledAppointmentsLabs} />
        <ProtectedRouteProvider exact path="/dcadmin/cases/rejected" featureName ={FEATURE_NAME.VIEW_LABS} component={RejectedAppointments} />
        <ProtectedRouteProvider exact path="/dcadmin/appointments/notAttended" featureName ={FEATURE_NAME.VIEW_LABS} component={NotAttended} />

        <ProtectedRouteProvider exact path="/dcadmin/appointments/all" featureName ={FEATURE_NAME.VIEW_LABS} component={AllAppointmentsLabs} />
        <ProtectedRouteProvider exact path="/dcoperations/appointments" featureName ={FEATURE_NAME.VIEW_LABS} component={NewAppointments} />
        <ProtectedRouteProvider exact path="/dcoperations/appointments/confirmed" featureName ={FEATURE_NAME.VIEW_LABS} component={ConfirmedAppointmentsLabs} />
        <ProtectedRouteProvider exact path="/dcoperations/documents/pending" featureName ={FEATURE_NAME.VIEW_LABS}  component={DocumentsPending} />
        <ProtectedRouteProvider exact path="/dcoperations/documents/partialReceived"  featureName ={FEATURE_NAME.VIEW_LABS} component={ParitalDocumentsReceived} />
        <ProtectedRouteProvider exact path="/dcoperations/documents/received" featureName ={FEATURE_NAME.VIEW_LABS} component={DocumentsSubmitted} />
        <ProtectedRouteProvider exact path="/dcoperations/cases/settled" featureName ={FEATURE_NAME.VIEW_LABS} component={SettledAppointments} />
        <ProtectedRouteProvider exact path="/dcoperations/cases/cancelled" featureName ={FEATURE_NAME.VIEW_LABS} component={CancelledAppointmentsLabs} />
        <ProtectedRouteProvider exact path="/dcoperations/cases/rejected" featureName ={FEATURE_NAME.VIEW_LABS} component={RejectedAppointments} />
        <ProtectedRouteProvider exact path="/dcoperations/appointments/notAttended" featureName ={FEATURE_NAME.VIEW_LABS} component={NotAttended} />
        {
          localStorage.getItem('user_details') &&
          ProvidersAffiliateOrders.includes(ValidateLocalStorageToken(localStorage.getItem('user_details'))?.providerId) &&
          <ProtectedRouteProvider exact path="/dcadmin/create/order" component={CreateOrder} />
        }
        <ProtectedRouteProvider exact path="/offlineConsults/allAppointments" featureName ={FEATURE_NAME.VIEW_OFFLINE}  component={AllAppointments} />
        <ProtectedRouteProvider exact path="/offlineConsults/upcoming" featureName ={FEATURE_NAME.VIEW_OFFLINE} component={UpcomingAppointments} />
        <ProtectedRouteProvider exact path="/offlineConsults/confirmed" featureName ={FEATURE_NAME.VIEW_OFFLINE} component={ConfirmedAppointments} />
        <ProtectedRouteProvider exact path="/offlineConsults/documentUpload" featureName ={FEATURE_NAME.VIEW_OFFLINE} component={DocumentUploadAppointments} />
        <ProtectedRouteProvider exact path="/offlineConsults/cancelled" featureName ={FEATURE_NAME.VIEW_OFFLINE} component={CancelledAppointments} />

        <Route path="/offlineConsults/DoctorManagements" component={PageRouter} />
        <Route path="/offlineConsults/DoctorManagement" component={DoctorManagement} />
        <Route path="/SPOC/SPOCManagements" component={AddEditSpoc} />
        <Route path="/SPOC/SPOCManagement" component={SPOCList} />



            <Route path="*" component={ErrorScreen} />
          </Switch>
          <ToastContainer position='bottom-right' delay={3000} />
          
    </div>
    </ThemeProvider>
  );
}

export default App;
